export default {
    routerName: '部門詳細',
    dept: {
        name: '部門名',
        parentName: '親部門名',
        leader: '責任者',
        mobile: '携帯電話',
        email: 'メール',
        status: '状態',
        open: '有効',
        close: '無効',
        sortOrder: 'ソート',
        createBy: '作成者',
        createTime: '作成日付',
        updateBy: '更新者',
        updateTime: '更新日付',
    },
};
